<template>
  <div>
    <!-- ヘッダ -->
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- データ入力エリア -->
        <v-simple-table class="simple-table">
          <template v-slot:default>
            <tbody>
              <tr v-for="item in desserts" :key="item.name">
                <td class="table-title" >{{ item.name }}</td>
                <td v-if="item.requiredFlg" class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
                </td>
                <td v-else class="table-title">
                  <label class="tbl-lbl-blcok"></label>
                </td>
                <td class="table-td-1">
                  <template v-if="item.name != '有効期間(開始)' && item.name != '有効期間(終了)'">
                    <v-text-field label="" :placeholder='item.placeholderChrs' dense solo :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval"></v-text-field>
                  </template>
                  <template v-if="item.name == '有効期間(開始)'">
                    <v-menu
                      v-model="menuSrtValidityperiodDateFlg"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          v-model="srtValidityperiodDate"
                          label=""
                          persistent-hint
                          clearable
                          prepend-icon="mdi-calendar"
                          background-color="white"
                          dense
                          solo
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="srtValidityperiodDate"
                        @input="menuSrtValidityperiodDateFlg = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>

                  <template v-if="item.name == '有効期間(終了)'">
                    <v-menu
                      v-model="menuEndValidityperiodDateFlg"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                          v-model="endValidityperiodDate"
                          label=""
                          persistent-hint
                          clearable
                          prepend-icon="mdi-calendar"
                          dense
                          solo
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endValidityperiodDate"
                        @input="menuEndValidityperiodDateFlg = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- ボタンエリア -->
        <v-row style="margin-top: 0px !important;">
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-btn x-large color="info" dark min-width="200px"  @click="register()">登録</v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-8" style="height: 10vh;"></v-row>
        
      </v-container>
    </v-main>
    <!-- フッター -->

    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
  </div>
</template>


<script>
import Constants from '../common/constants';
import Utils from '../common/utils';
export default {
  name: "ManagerRegist",
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: "管理ユーザ新規登録",
      screenId: "MTO200",
      messageArea: "",
      desserts: [
        { name: "ユーザID", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "氏名", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "氏名（フリガナ）", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "パスワード", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "パスワード(確認)", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "有効期間(開始)", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "有効期間(終了)", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: false },
      ],
      srtValidityperiodDate: new Date().toISOString().substr(0, 10),
      endValidityperiodDate: new Date().toISOString().substr(0, 10),
      menuSrtValidityperiodDateFlg: false,
      menuEndValidityperiodDateFlg: false,
      kbnTypPolicy: "200",
      KbnCdService: "0",
      pswdFlg: false,
      password: "Password",
      contactUsDspFlg: false,
      moveTopButtonPos: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 12 || "Min 12 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  methods : {
   /*
    * 初期表示
    */
    initialize: function() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mto200.area');
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setMainteLoginInfoMixin();
      this.username = authInfo['username'];
      this.deptname = authInfo['deptname'];
    },
    /*
    * 登録ボタン押下
    */
    register: async function () {


      // 管理ユーザ登録サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let apiurl = Constants.URL_API_MTO200P01;
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error;
      } finally {
        this.loading = false;
      }
      // 完了メッセージ表示 & 次画面遷移
      this.showDialogMsgAfterAPICall(apiErrorInfo, responseData);
    },
    
   /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm111', ['管理ユーザ']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },

   /*
    * 登録用リクエストデータ生成
    */
    createRequestData : function() {
      let reqData = {};
      for (const value of this.desserts) {
        switch (value.name) {
          case 'ユーザID':
            reqData['userNo'] = value.inputval;
            break;
          case '氏名':
            reqData['name'] = value.inputval;
            break;
          case '氏名（フリガナ）':
            reqData['nameKana'] = value.inputval;
            break;
          case 'パスワード':
            reqData['pw'] = value.inputval;
            break;
          case 'パスワード(確認)':
            reqData['pwConfirm'] = value.inputval;
            break;
          case '有効期間(開始)':
            reqData['validityperiodStartDate'] = this.srtValidityperiodDate;
            break;
          case '有効期間(終了)':
            reqData['validityperiodEndDate'] = this.endValidityperiodDate;
            break;
        }
      }
      return reqData;
    },
  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}

@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 96%;
    margin: 5px 5px;
  }
  .table-title {
    background-color: #f2f2f2;
    width: 34%;
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    background-color: #f2f2f2;
    width: 20%;
    text-align: right;
  }
}
</style>